import { StatusEnum } from "./status-enum";

export const statusLabels = {
  [StatusEnum.RECEIVED]: "Diterima",
  [StatusEnum.PARTIALLY_INVOICED]: "Difaktur Sebagian",
  [StatusEnum.FULLY_INVOICED]: "Difaktur",
};
